import { render, staticRenderFns } from "./Toppersonbubblepinnedhistory.vue?vue&type=template&id=779bfd1a"
import script from "./Toppersonbubblepinnedhistory.vue?vue&type=script&lang=js"
export * from "./Toppersonbubblepinnedhistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports